import { CommonModule } from '@angular/common'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { BaseAtylModule } from '../base/base.module'
import { MaterialModule } from '../material.module'
import { PipesModule } from '../pipes/pipes.module'
import { DesignModule } from '../views/partials/design/design.module'
import { PartialsModule } from '../views/partials/partials.module'
import { AdderComponent } from './adder/adder.component'
import { ConfigurateurComponent } from './configurateur/configurateur.component'
import { DossierRendererComponent } from './configurateur/dossier-renderer/dossier-renderer.component'
import { SecurityHandlerComponent } from './dialogs/security-handler/security-handler.component'
import { NomadeInterceptorService } from './interceptor/nomade.interceptor.service'
@NgModule({
	declarations: [
		ConfigurateurComponent,
		AdderComponent,
		DossierRendererComponent,
		SecurityHandlerComponent
	],
	imports: [
		CommonModule,
		BaseAtylModule,
		FormsModule,
		ReactiveFormsModule,
		MaterialModule,
		DesignModule,
		PartialsModule,
		HttpClientModule,
		PipesModule,
		RouterModule.forChild([{
			path: '',
			component: ConfigurateurComponent
		}])
	],
	exports: [
		ConfigurateurComponent,
		AdderComponent,
		DossierRendererComponent
	],
	entryComponents: [
		SecurityHandlerComponent
	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: NomadeInterceptorService,
			multi: true
		}
	]
})
export class NomadeModule { }
